export const ERROR_TYPE = {
  pageNotFound: 'page.not_found',
  orderNotFound: 'order.not_found',
} as const;

export type ErrorTypeKey = keyof typeof ERROR_TYPE;
export type ErrorTypeValue = (typeof ERROR_TYPE)[ErrorTypeKey];

interface ErrorTextEntry {
  title: string;
  subTitle: string;
  linkText?: string;
  link?: string;
}

export const ERROR_TEXT: Record<ErrorTypeValue, ErrorTextEntry> = {
  [ERROR_TYPE.pageNotFound]: {
    title: "Sorry, we can\u2019t find that page",
    subTitle: "We can\u2019t seem to find the page that you\u2019re looking for. Please try again, or start from our home page.",
  },
  [ERROR_TYPE.orderNotFound]: {
    title: "We can\u2019t find an order with those details",
    subTitle: 'Please check and try again, or contact us.',
    linkText: 'Track another order',
    link: '/order-tracker',
  },
};
